'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.faqsCategories = void 0;
var adapter_1 = require("../adapter");
var FAQsCategories = /** @class */ (function () {
    function FAQsCategories() {
    }
    /**
     * Get FAQs for given language
     */
    FAQsCategories.prototype.get = function (lang) {
        var params = { lang: lang };
        return adapter_1.adapter.faqsCategories.get(params);
    };
    return FAQsCategories;
}());
exports.faqsCategories = new FAQsCategories();
